import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { OrigenService } from './core/services/origen.service';
import { TenantService } from './core/services/tenant.service';
import { ToastContainerComponent } from './shared/components/common/toast/toast-container.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    ToastContainerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'Angular Ecommerce Dashboard | TailAdmin';

  constructor(private tenantService: TenantService, private origen: OrigenService, private router: Router) {
    // De dónde vino (campaña, referido, plan elegido): se lee al entrar y se manda
    // cuando ya hay una cuenta de dueño con la sesión abierta.
    this.origen.capturar();
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => this.origen.enviar());
  }

  ngOnInit() {
    // Detectar y cargar el tenant desde el dominio al iniciar la app
    this.tenantService.initialize().subscribe({
      next: (tenant) => {
        if (tenant) {
          console.log('Tenant detectado:', tenant.slug);
        } else {
          console.log('Modo central (Owner/Admin)');
        }
      },
      error: (error) => {
        console.error('Error al inicializar tenant:', error);
      }
    });
  }
}
